<script>
    import { get_cookies, update_cookies } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/cookies.js?1733898724857';
    import { messages } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/stores/messages.js?1733898724857';
    import { onMount } from 'svelte';

    wyvr: {
        render: 'hydrate';
        loading: 'instant';
    }

    onMount(() => {
        const cookies = get_cookies();
        if (cookies && cookies['mage-messages']) {
            let list = [];

            // parse magento messages out of the cookie
            try {
                list = JSON.parse(decodeURIComponent(cookies['mage-messages']));
            } catch (jsonError) {
                try {
                    list.push({ text: decodeURIComponent(cookies['mage-messages']), type: 'error' });
                } catch (uriError) {
                    console.error(jsonError);
                    console.error(uriError);
                }
            }
            list.filter(Boolean).forEach((message) => {
                const text = message.text.replace(/\+/g, ' ');
                messages.push(text, message.type == 'success' ? 'success' : 'error');
            });
            // remove mage-messages
            update_cookies({ 'mage-messages': undefined }, '/');
        }
    });
</script>
